import React from "react";
import LocutionsGrecques from "../data/LocutionsGrecques.json";
import LocutionsLatines from "../data/LocutionsLatines.json";

function MakeLocution() {
  function NoteOuAuteur(totalSentence, random) {
    let noteOuAuteur = "";
    if (totalSentence[random].note) {
      noteOuAuteur = (
        <div id="auteur-et-note">{"(" + totalSentence[random].note + ")"}</div>
      );
    } else if (totalSentence[random].auteur) {
      noteOuAuteur = (
        <div id="auteur-et-note">{totalSentence[random].auteur}</div>
      );
    }
    return noteOuAuteur;
  }

  let random = Math.floor(
    Math.random() * Number(LocutionsLatines.length + LocutionsGrecques.length)
  );
  let totalSentence = [...LocutionsLatines];
  let finalLocution = "";

  for (let i = 0; i < Number(LocutionsGrecques.length); i++) {
    totalSentence.push(LocutionsGrecques[i]);
  }
  if (totalSentence[random].latin) {
    finalLocution = (
      // si la citation est latine
      <ul id="container-locution">
        <li id="locution">{totalSentence[random].latin}</li>
        {NoteOuAuteur(totalSentence, random)}
        <li id="traduction-locution">{totalSentence[random].traduction}</li>
      </ul>
    );
  } else if (totalSentence[random].grec) {
    finalLocution = (
      // si la locution est grecque
      <ul id="container-locution">
        <li id="locution">{totalSentence[random].grec}</li>
        <li id="alphabetlatin">
          {"[" + totalSentence[random].alphabetlatin + "]"}
        </li>
        {NoteOuAuteur(totalSentence, random)}
        <li id="traduction-locution">{totalSentence[random].traduction}</li>
      </ul>
    );
  }

  return finalLocution;
}

export default MakeLocution;



// WEBPACK FOOTER //
// ./src/components/MakeLocution.js